<template>
  <v-container style="max-width: 1600px;">
    <h1
      style="text-align: center; text-transform: uppercase; line-height: 1.1;"
    >Cuddly Ghost Stickers</h1>
    <v-row>
      <v-col cols="6" sm="4" lg="3" v-for="sticker in this.stickers" :key="sticker.id">
        <img
          @click="selectSticker(sticker)"
          class="thumbnail"
          v-bind:src="sticker.thumbnail"
          alt
          style="width: 100%; cursor: pointer"
        />
        <p
          @click="selectSticker(sticker)"
          style="cursor: pointer; text-align: center; margin: 0px; padding: 0px; text-transform: capitalize;"
        >{{sticker.title}}</p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import UserService from "@/services/UserService";

export default {
  data: () => ({
    error: "",
    stickers: null
  }),
  async mounted() {
    // If no query, show homepage
    // If there is a query, find the sticker, set it, and change the page
    if (this.$route.query.sticker == undefined) {
      const response = await UserService.getStickers();
      // Randomly reorder the stickers
      this.shuffleArray(response.data.stickers);
      this.stickers = response.data.stickers;
    } else {
      // Search database and set selected sticker to whatever the query is
      let stickerSlug = {
        slug: this.$route.query.sticker
      };
      const response = await UserService.getSticker(stickerSlug);
      this.$store.dispatch("setSelectedSticker", response.data.sticker);
      this.$router.push(
        `/selectedSticker/?sticker=${this.$route.query.sticker}`
      );
    }
  },
  methods: {
    selectSticker(sticker) {
      this.$store.dispatch("setSelectedSticker", sticker);
      this.$router.push(`/selectedSticker/?sticker=${sticker.slug}`);
    },
    shuffleArray(array) {
      for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
      }
    }
  }
};
</script>

<style scoped>
.thumbnail {
  border: 1px solid grey;
  box-shadow: 5px 5px 5px grey;
  border-radius: 10px;
}

.thumbnail:hover {
  box-shadow: 0 0 15px 5px rgb(112, 112, 112);
}

.shadow {
  border: 1px solid grey;
  box-shadow: 5px 5px 5px grey;
}

.rounded {
  border-radius: 10px;
}
</style>
